import Icon from '@components/icon/Icon';
import Tooltip from '@components/tooltip/Tooltip';
import { RadioButtonProps } from 'types/button';

import theme from '../../../themes/colors';

const labelStyles = {
  common: 'text-sm text-grey ml-4'
};

const inputStyles = {
  common: 'h-4 w-4 border-subText'
};

const RadioButton = ({
  isSelected,
  label,
  onChange,
  value,
  labelStyle,
  buttonId,
  element,
  className,
  iconStyle = '',
  tooltipText = '',
  customTooltipStyle = '',
  linkLabelToInput = false,
  ...props
}: RadioButtonProps) => {
  const tooltipId = `radio-button-tooltip-${buttonId || label}`;
  const inputId = buttonId || label;
  const labelFor = linkLabelToInput ? inputId : label;
  const pointerClass = linkLabelToInput ? 'cursor-pointer ' : '';

  return (
    <>
      <div
        className={`flex items-center ${className}`}
        data-tooltip-id={tooltipText ? tooltipId : undefined}
      >
        <input
          type="radio"
          onChange={onChange}
          id={inputId}
          data-testid={buttonId}
          value={value}
          {...props}
          checked={isSelected}
          className={`${pointerClass}accent-green-700 ${inputStyles.common} ${iconStyle}`}
        />
        <label
          htmlFor={labelFor}
          className={`${pointerClass}${labelStyles.common} ${labelStyle}`}
        >
          <div>{element || label}</div>
        </label>
      </div>
      {tooltipText && (
        <Tooltip id={tooltipId} place="top" className={customTooltipStyle}>
          <div className="flex items-center gap-[6px]">
            <Icon name="alert-circle" stroke={theme.subText} size="medium" />
            <span>{tooltipText}</span>
          </div>
        </Tooltip>
      )}
    </>
  );
};

export default RadioButton;
